import type { AxiosRequestConfig } from 'axios';

import { devBackend } from 'src/util/devBackend';

const APP_APEX_HOSTNAMES = [
	'infra-struktur.eu',
	'infra-struktur.com',
	'infra-struktur.net',
	'infra-struktur.app',
] as const;

const parsedUrl = (value: string, base?: string): URL | null => {
	try {
		return base === undefined ? new URL(value) : new URL(value, base);
	} catch {
		return null;
	}
};

const browserHref = (): string | undefined => {
	if (typeof window === 'undefined' || typeof window.location?.href !== 'string') return undefined;
	return window.location.href;
};

const requestDestination = (config: AxiosRequestConfig): URL | null => {
	if (typeof config.url !== 'string' || config.url.trim() === '') return null;

	const absoluteRequestUrl = parsedUrl(config.url);
	if (absoluteRequestUrl !== null) return absoluteRequestUrl;

	const currentHref = browserHref();
	if (typeof config.baseURL === 'string' && config.baseURL.trim() !== '') {
		const baseUrl = parsedUrl(config.baseURL, currentHref);
		return baseUrl === null ? null : parsedUrl(config.url, baseUrl.href);
	}

	return currentHref === undefined ? null : parsedUrl(config.url, currentHref);
};

const isAppHostname = (hostname: string): boolean => {
	const pinned = devBackend();
	return (
		hostname === 'localhost' ||
		(pinned !== null && hostname === new URL(pinned.origin).hostname) ||
		APP_APEX_HOSTNAMES.some((apexHostname) => hostname === apexHostname || hostname.endsWith('.' + apexHostname))
	);
};

export function appAuthenticationHeadersAreEnabledForRequest(config: AxiosRequestConfig): boolean {
	if (config.skipAppAuthenticationHeaders === true) return false;
	const destination = requestDestination(config);
	return destination !== null && isAppHostname(destination.hostname);
}
